module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/changelog-63.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/changelog.md
// module id = 480
// module chunks = 458